/*
  Bankstown Sound -- product card badges for THIRD-PARTY pages.

  The compare (Comparable, /pages/compare) and wishlist (Wishlist by Square,
  /apps/api/list) pages render their OWN product cards, so our Liquid badges
  never run there. Product price + tags ARE readable client-side via
  /products/<handle>.js, so on these pages we, per card:

    1. Read the product handle and fetch /products/<handle>.js.
    2. COMPARE only: if on sale, inject a red "-NN%" discount pill (top-left).
       (Wishlist already shows the app's own ".wls-sale-badge", so we don't add
       a second sale indicator there.)
    3. For each tag in FREE_BADGES the product carries, inject a red pill --
       to the RIGHT of any sale indicator / previously injected pill, or alone
       in the top-left corner when nothing precedes it.

  Mirrors bts-instore-guard.js. Robust against async app rendering via a
  MutationObserver (wishlist cards render late). All badge CSS is !important --
  the app markup would otherwise reset padding / display.
*/
(function () {
  var FREE_BADGES = [
    { tag: 'free-install', mod: 'free', label: 'Free Installation' },
    { tag: 'free-reverse-camera', mod: 'free-rc', label: 'Free Reverse Camera' }
  ];

  var path = location.pathname;
  var scopes = [];
  if (/\/pages\/compare/.test(path) || document.body.classList.contains('comparison-page')) {
    // Comparable: image in a.comparable-link; no native sale badge -> we add one.
    scopes.push({ card: '.product-summary', media: '.comparable-link', sale: null, discount: true });
  }
  if (/\/apps\/api\/list/.test(path)) {
    // Wishlist by Square: image in .wls-card-media; app already shows .wls-sale-badge.
    scopes.push({ card: '.wls-card', media: '.wls-card-media', sale: '.wls-sale-badge', discount: false });
  }
  if (!scopes.length) { return; }

  // ---- injected styles -----------------------------------------------------
  // !important throughout: these badges live inside app-owned markup whose CSS
  // would otherwise reset padding / display (e.g. the wishlist app zeroes them).
  var css = '';
  css += '.bts-fi-host{position:relative!important;}';
  css += '.bts-fi-badge{position:absolute!important;top:12px!important;left:12px!important;z-index:3!important;'
       + 'display:inline-flex!important;align-items:center!important;justify-content:center!important;'
       + 'box-sizing:border-box!important;width:auto!important;height:auto!important;margin:0!important;'
       + 'padding:5px 10px!important;background-image:none!important;color:#fff!important;border:0!important;'
       + 'border-radius:10px!important;font-family:Gotham,"Proxima Nova",Arial,sans-serif!important;'
       + 'font-weight:600!important;font-size:11px!important;line-height:1!important;letter-spacing:0!important;'
       + 'text-transform:none!important;white-space:nowrap!important;pointer-events:none!important;}';
  css += '.bts-fi-badge--sale{background:#c62d2d!important;}';
  css += '.bts-fi-badge--free{background:#c62d2d!important;}';
  css += '.bts-fi-badge--free-rc{background:#c62d2d!important;}';
  var st = document.createElement('style');
  st.setAttribute('data-bts-free-install', '');
  st.textContent = css;
  (document.head || document.documentElement).appendChild(st);

  // ---- helpers -------------------------------------------------------------
  var cache = {};
  function getProduct(handle) {
    if (cache[handle]) { return cache[handle]; }
    cache[handle] = fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return cache[handle];
  }
  function hasTag(p, tag) {
    if (!p) { return false; }
    return (p.tags || []).some(function (t) { return String(t).trim().toLowerCase() === tag; });
  }
  function handleOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) { return null; }
    var m = (a.getAttribute('href') || '').match(/\/products\/([^?\/#]+)/);
    return m ? m[1] : null;
  }
  function mediaOf(s, card) {
    var el = card.querySelector(s.media);
    if (el) { return el; }
    var img = card.querySelector('img');
    return img ? img.parentElement : null;
  }
  function makeBadge(kind, text) {
    var b = document.createElement('span');
    b.className = 'bts-fi-badge bts-fi-badge--' + kind;
    b.textContent = text;
    return b;
  }

  function inject(s, card, p) {
    var media = mediaOf(s, card);
    if (!media) { return false; }
    media.classList.add('bts-fi-host');

    var onSale = s.discount && p && p.compare_at_price && p.compare_at_price > p.price;
    var appSale = s.sale ? card.querySelector(s.sale) : null;

    // discount pill (compare only) -- top-left
    if (onSale && !card.querySelector('.bts-fi-badge--sale')) {
      var pct = Math.round((p.compare_at_price - p.price) * 100 / p.compare_at_price);
      media.appendChild(makeBadge('sale', '-' + pct + '%'));
    }

    // free-* pills -- each to the RIGHT of whatever precedes it (the sale
    // indicator, or a previously injected pill); alone in the top-left if none.
    var prevEl = card.querySelector('.bts-fi-badge--sale') || appSale;
    FREE_BADGES.forEach(function (b) {
      var cls = 'bts-fi-badge--' + b.mod;
      if (!hasTag(p, b.tag) || card.querySelector('.' + cls)) { return; }
      var badge = makeBadge(b.mod, b.label);
      media.appendChild(badge);
      if (prevEl) {
        var mRect = media.getBoundingClientRect();
        var pRect = prevEl.getBoundingClientRect();
        if (pRect.width > 0) {
          // inline !important to beat the base rule's `left:12px!important`
          badge.style.setProperty('left', (Math.round(pRect.right - mRect.left) + 8) + 'px', 'important');
        }
      }
      prevEl = badge;
    });
    return true;
  }

  function process() {
    scopes.forEach(function (s) {
      [].forEach.call(document.querySelectorAll(s.card), function (card) {
        if (card.__btsFiState === 'done') { return; }
        var handle = handleOf(card);
        if (!handle) { return; }               // not ready -> retry on mutation
        if (!mediaOf(s, card)) { return; }     // image not ready -> retry
        if (card.__btsFiState === 'pending') { return; }
        card.__btsFiState = 'pending';
        getProduct(handle).then(function (p) {
          if (inject(s, card, p) === false) { card.__btsFiState = null; return; }
          card.__btsFiState = 'done';
        });
      });
    });
  }

  var pending = false;
  function schedule() {
    if (pending) { return; }
    pending = true;
    setTimeout(function () { pending = false; process(); }, 120);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', process); }
  else { process(); }
  var mo = new MutationObserver(schedule);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
